// MSAL configuration for Azure AD
export const msalConfig = {
  auth: {
    clientId: import.meta.env.VITE_AZURE_CLIENT_ID,
    authority: 'https://login.microsoftonline.com/9b50c80f-103b-4433-a91c-b4b06c507387',
    redirectUri: window.location.origin,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: true, // Enable cookies for IE11/Edge support
  },
};

export const loginRequest = {
  scopes: [import.meta.env.VITE_AZURE_API_SCOPE],
};
